import React from 'react'
import { css, StyleSheet } from 'aphrodite'
import PropTypes from 'prop-types'
import { IconEye, IconTrash, IconEdit } from '../../components/Icon'
import UIButtonIcon from '../../components/UI/UIButtonIcon'

const styles = StyleSheet.create({
  actions: {
    display: 'flex',
    alignItems: 'center',
  },
})

const UIActions = ({ handleIconEye, handleIconTrash, handleIconEdit }) => {
  return (
    <div className={css(styles.actions)}>
      <UIButtonIcon onClick={handleIconEye}>
        <IconEye />
      </UIButtonIcon>
      <UIButtonIcon onClick={handleIconTrash}>
        <IconTrash />
      </UIButtonIcon>
      {handleIconEdit && (
        <UIButtonIcon onClick={handleIconEdit}>
          <IconEdit />
        </UIButtonIcon>
      )}
    </div>
  )
}

UIActions.propTypes = {
  handleIconEye: PropTypes.func,
  handleIconTrash: PropTypes.func,
  handleIconEdit: PropTypes.func,
}

export default UIActions
